import * as React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import AutoInfoCatalogue from './AutoInfoCatalogue';
import { IAutoInfoCatalogueProps } from './AutoInfoCatalogue.properties';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {},
  dispatch);

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(
  (props: Readonly<Omit<IAutoInfoCatalogueProps, 'classes'>>) => {
    return <AutoInfoCatalogue {...props} />;
  }
);

export default React.forwardRef(
  (props: Readonly<Omit<IAutoInfoCatalogueProps, 'classes'>>) => {

    return <ConnectedComponent {...props} />;
  });
